import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'redux/store';
import { RootState } from 'redux/schemas';
import { getAiRolePlay } from 'redux/selectors/timeline';
import { fetchAiRolePlay } from 'redux/actions/ai-role-play';

/* @ngInject */
export default function useAiRolePlay(aiRolePlayId: number) {
  const dispatch = useAppDispatch();
  const aiRolePlay = useSelector((state: RootState) => getAiRolePlay(state, aiRolePlayId));

  useEffect(() => {
    if (!aiRolePlay && aiRolePlayId) {
      dispatch(fetchAiRolePlay({ aiRolePlayId }));
    }
  }, [aiRolePlay, aiRolePlayId, dispatch]);

  return aiRolePlay;
}
